module.exports = __webpack_public_path__ + "img/agency.2462e5b5.svg";